import {createMarquee} from "../_functions";

createMarquee(".header__marquee--wrap", ".marquee-item", 40, 36);
